export function normalizeManualWorkInsertRowMachineData(row) {
  if (!row || typeof row !== "object") {
    return row;
  }

  const normalizedRow = { ...row };
  const sourceWorkMachines = Array.isArray(row.work_machines) ? row.work_machines : [];
  if (sourceWorkMachines.length === 0) {
    return normalizedRow;
  }

  const mappedMachines = sourceWorkMachines
    .map((machineEntry) => {
      const machinePayload = machineEntry?.machine && typeof machineEntry.machine === "object" ? machineEntry.machine : machineEntry;
      const machineUuid = machinePayload?.uuid || machineEntry?.work_machine_uuid || machineEntry?.machine_uuid || null;
      const registrationNumber = machinePayload?.registration_number || machineEntry?.registration_number || "";
      const machineName = registrationNumber || machinePayload?.name || machineEntry?.machine_name || "";

      if (!machineName && !machineUuid) {
        return null;
      }

      return machineUuid
        ? {
            uuid: machineUuid,
            name: machineName,
            registration_number: registrationNumber,
          }
        : {
            name: machineName,
            registration_number: registrationNumber,
          };
    })
    .filter(Boolean);

  if (mappedMachines.length === 0) {
    return normalizedRow;
  }

  normalizedRow.machines = mappedMachines;

  if (!normalizedRow.machine_name) {
    normalizedRow.machine_name = mappedMachines[0].name;
  }

  if (!normalizedRow.machine_uuid && mappedMachines[0].uuid) {
    normalizedRow.machine_uuid = mappedMachines[0].uuid;
  }

  if (!normalizedRow.work_machine) {
    normalizedRow.work_machine = { ...mappedMachines[0] };
  }

  return normalizedRow;
}

export function normalizeManualWorkInsertResponseData(responseData) {
  if (Array.isArray(responseData)) {
    return responseData.map((row) => normalizeManualWorkInsertRowMachineData(row));
  }

  if (Array.isArray(responseData?.data)) {
    return responseData.data.map((row) => normalizeManualWorkInsertRowMachineData(row));
  }

  if (Array.isArray(responseData?.items)) {
    return responseData.items.map((row) => normalizeManualWorkInsertRowMachineData(row));
  }

  const singleItem =
    responseData?.data && typeof responseData.data === "object" && !Array.isArray(responseData.data) ? responseData.data : responseData;

  if (singleItem && typeof singleItem === "object") {
    const hasUsefulFields =
      singleItem.uuid ||
      singleItem.spc_uuid ||
      singleItem.season_on_parcel_has_culture_uuid ||
      singleItem.work ||
      singleItem.work_uuid ||
      singleItem.work_date ||
      singleItem.net_surface_worked;

    if (hasUsefulFields) {
      return [normalizeManualWorkInsertRowMachineData(singleItem)];
    }
  }

  return [];
}
